import { Link } from "react-router-dom";
import {
  Row,
  Col,
  Container,
  Button,
  InputGroup,
  FormControl,
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTwitter, faFacebook, faInstagram, faLinkedinIn } from '@fortawesome/free-brands-svg-icons'

import MobileStoreButton from '../../Components/MobileStoresButton';
import logoWithColoredTxt from '../../Assets/Images/logo/logoWithColoredTxt-removebg-preview.png';

import './style.scss';

const Footer = () => {
  return (
    <div id='footer'>
      <Container>
        <Row>
          <Row className="mb-5">
            <Col>
              <img
                src={logoWithColoredTxt}
                width="100"
                height="35"
                className="d-inline-block align-top"
                alt="React Bootstrap logo"
              />
            </Col>
          </Row>
          <Col lg={5} md={10} sm={12} xs={12}>
            <h4>Let's Stay Connected</h4>
            <div className="mb-4">
              <a href="https://www.instagram.com/info.jamlyf" target="blank">
                <FontAwesomeIcon
                  icon={faInstagram}
                  size="lg"
                  className="social-icons"
                  color="#e1306c"
                />
              </a>
              {/* <FontAwesomeIcon icon={faFacebook} size="lg" className="social-icons" />
              <FontAwesomeIcon icon={faLinkedinIn} size="lg" className="social-icons" />
              <FontAwesomeIcon icon={faTwitter} size="lg" className="social-icons" /> */}
            </div>
            {/* <h6>Subscribe to our mailing list</h6>
            <InputGroup className="mt-3 sub-form">
              <FormControl
                placeholder="Enter your email"
                aria-label="Enter your email"
                aria-describedby="basic-addon2"
              />
              <Button variant="outline-secondary" id="button-addon2">
                Submit
              </Button>
            </InputGroup> */}
          </Col>
          <Col lg={3} md={6} sm={12} xs={12} className="footerSupport">
            <h4>Support</h4>
            <Link to="/faq" className="link">FAQs</Link>
            <Link to="/contactus" className="link">Contact Us</Link>
            {/* <Link to="/" className="link">Feedback</Link> */}
          </Col>
          <Col lg={4} md={10} sm={12} xs={12}>
            <div className="empty-div"/>
            <Link to="/terms-and-policies" className="link terms">Terms and Conditions</Link>
            {/* <div className='plat-btn-container'>
              <MobileStoreButton store='ios' url='#home' divClassName='plat-btn' />
              <MobileStoreButton id='android-btn' store='android' url='#home' divClassName='plat-btn' />
            </div> */}
          </Col>
        </Row>
      </Container>
    </div>
  )
}
export default Footer;
